import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { Link } from 'react-router-dom';
import { History } from 'history';
import { resetSpecialAccessState } from '../state/actions';
import {
    login, signup, forgotPassword, getUser,
} from '../../auth/state/actions/user';
import { openModal } from '../../../actions/modal';
import IconClose from '../../../assets/icons/IconClose';
import BaseModal from '../../../components/modals/newModals/BaseModal';
import { mpTrackingPopups } from '../../../config/popups';
import newtheme from '../../../newtheme';
import theme from '../../../theme';
import { mpTrackPopupView } from '../../../tracking/mixpanel';
import ModalTypes from '../../../types/ModalTypes';
import { isEmailValid } from '../../../utils/text';
import { LOGIN_SUCCESS, SIGNUP_SUCCESS } from '../../auth/state/constants/user';
import config from '../../../config';
import text from '../../../locale';
import Input from '../../../components/Input';
import Button from '../../../components/buttons/Button';
import { isServer } from '../../../../store';
import ISpecialAccessResponse from '../types/ISpecialAccessResponse';

interface ILocalProps {
    open: boolean;
    close: any;
    email: string;
    history: History;
    accessData: ISpecialAccessResponse;
    authError?: Error;
    login: typeof login;
    signup: typeof signup;
    forgotPassword: typeof forgotPassword;
    getUser: typeof getUser;
    openModal: typeof openModal;
    resetSpecialAccessState: typeof resetSpecialAccessState;
}

interface ILocalState {
    name: string;
    password: string;
}

class SignupForSpecialAccessModalComponent extends React.Component<ILocalProps, ILocalState> {
    constructor(props: ILocalProps) {
        super(props);

        this.state = {
            name: '',
            password: '',
        };
    }

    public componentDidMount = () => {
        mpTrackPopupView(mpTrackingPopups.freeAccessConfirmed);
    };

    public auth = () => {
        if (this.props.accessData.alreadyHasAccount) {
            this.login();
            return;
        }

        this.signup();
    };

    public signup = () => {
        const { name, password } = this.state;
        const { email } = this.props;

        if (!isEmailValid(email) || !password || !name) {
            return;
        }

        this.props
            .signup({
                name,
                email,
                password,
            })
            // @ts-ignore
            .then((resp) => {
                if (resp && resp.type === SIGNUP_SUCCESS) {
                    this.props.getUser();
                    this.props.close();
                    this.props.openModal(ModalTypes.DownloadTheApp);
                    this.props.history.push(config.routes.homeWebPlayer);
                }
            });
    };

    public login = () => {
        const { email } = this.props;
        const { password } = this.state;

        if (!isEmailValid(email) || !password) {
            return;
        }

        this.props
            .login({
                email,
                password,
            })
            // @ts-ignore
            .then((resp) => {
                if (resp && resp.type === LOGIN_SUCCESS) {
                    this.props.getUser();
                    this.props.close();
                    this.props.openModal(ModalTypes.DownloadTheApp);
                    this.props.history.push(config.routes.homeWebPlayer);
                }
            });
    };

    public onChangeName = (value: string) => {
        this.setState({ name: value });
    };

    public onChangePassword = (value: string) => {
        this.setState({ password: value });
    };

    public onSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
        evt.preventDefault();
    };

    public render() {
        const {
            open, close, email, accessData, authError,
        } = this.props;
        const { name, password } = this.state;

        if (isServer) {
            return <></>;
        }

        const isLogin = accessData.alreadyHasAccount;

        return (
            <BaseModal modalId="ModalSignup" isOpen={open} onClose={close} title="Congratulations" height="EXTRA_LARGE" scrollable={false} fullScreenMobile>
                <div className={css(styles.modalWrapper)}>
                    {/* Right styles */}
                    <div className={css(rightStyles.main)}>
                        <div className={css(rightStyles.closeIconWrapper)} onClick={close}>
                            <IconClose className={css(rightStyles.closeIcon)} />
                        </div>

                        <h1 className={css(rightStyles.title)}>Congratulations</h1>
                        <p className={css(rightStyles.desc)}>
                            You have free Premium access to Noa.
                            <br />
                            {isLogin ? 'As you already have a Noa account,\nsimply log in to claim.' : 'Create your profile to start listening now.'}
                        </p>

                        <form onSubmit={this.onSubmit} className={css(rightStyles.form)}>
                            <Input id="signup-email" type="email" placeholder={email} onChange={() => null} value={email} required disabled />
                            {!isLogin && <Input id="signup-name" type="text" placeholder={text.signupModal.NAME} onChange={this.onChangeName} value={name} required />}
                            <Input id="signup-password" type="password" placeholder={text.signupModal.PASSWORD} onChange={this.onChangePassword} value={password} required />
                            <Button borderRadius={10} className={css(rightStyles.signupButton)} text={isLogin ? 'Log in and start listening' : 'Sign up and start listening'} onClick={this.auth} submit />
                            {authError && isLogin && <p className={css(rightStyles.error)}>An error occurred. Is your password correct?</p>}
                            {authError && !isLogin && <p className={css(rightStyles.error)}>An error occurred. Check your email and password.</p>}
                            {isLogin && (
                                <Link onClick={this.props.close} to={config.routes.resetPasswordInit} className={css(newtheme.coreStyles.highlightLinkDark, rightStyles.forgotPasswordLink)}>
                                    Forgot your password?
                                </Link>
                            )}
                        </form>

                        <div>
                            <div className={css(rightStyles.terms)}>
                                <span>
                                    {!isLogin ? 'By creating an account' : 'By logging in'}
                                    , you agree to Noa&apos;s&nbsp;
                                    <br />
                                    <Link className={css(newtheme.coreStyles.highlightLinkDark)} to={config.routes.terms} target="_blank">
                                        Terms of Service
                                    </Link>
                                    &nbsp;&amp;&nbsp;
                                    <Link className={css(newtheme.coreStyles.highlightLinkDark)} to={config.routes.privacy} target="_blank">
                                        Privacy Policy
                                    </Link>
                                    .
                                </span>
                            </div>
                        </div>

                        <div className={css(rightStyles.chatToUs)}>
                            <p>
                                Have an issue?
                                {' '}
                                <span id={text.nav.CONTACT} className={css(newtheme.coreStyles.highlightLinkDark)}>Chat to us</span>
                            </p>
                        </div>
                    </div>
                </div>
            </BaseModal>
        );
    }
}

const rightStyles = StyleSheet.create({
    main: {
        [newtheme.cssBreakpoints.large]: {
            padding: 40,
        },
        [newtheme.cssBreakpoints.medium]: {
            padding: '40px 30px',
        },
        [newtheme.cssHeightBreakpoints.large]: {
            padding: '40px 30px',
        },
        [newtheme.cssHeightBreakpoints.medium]: {
            padding: '20px 30px',
        },
        [newtheme.cssBreakpoints.small]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        [newtheme.cssBreakpoints.tiny]: {
            padding: 20,
            paddingTop: 5,
            paddingBottom: 30,
        },
        [newtheme.cssBreakpoints.smallerThanTiny]: {
            padding: 10,
        },
        height: '100%',
        backgroundColor: 'white',
        width: 540,
        padding: '40px 60px',
    },
    title: {
        fontSize: 30,
        [newtheme.cssHeightBreakpoints.large]: {
            fontSize: 24,
        },
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 27,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 24,
        },
        [`@media (max-width: ${theme.breakpoints.minuscule}px)`]: {
            fontSize: 20,
        },
        width: '100%',
        textAlign: 'center',
        marginBottom: 5,
        fontWeight: 600,
    },
    desc: {
        fontSize: 16,
        [newtheme.cssHeightBreakpoints.large]: {
            fontSize: 14,
            marginBottom: 20,
        },
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 15,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 14,
            marginBottom: 20,
        },
        [`@media (max-width: ${theme.breakpoints.minuscule}px)`]: {
            fontSize: 12,
            marginBottom: 15,
        },
        width: '100%',
        textAlign: 'center',
        marginBottom: 30,
        color: '#06032F',
        whiteSpace: 'pre-wrap',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: 20,
    },
    signupButton: {
        [newtheme.cssHeightBreakpoints.large]: {
            height: 45,
            minHeight: 45,
            fontSize: 15,
            borderRadius: 5,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            marginTop: 10,
            width: '100%',
            minWidth: '100%',
            height: 55,
            minHeight: 55,
            fontSize: 16,
        },
        [`@media (max-width: ${theme.breakpoints.minuscule}px)`]: {
            height: 40,
            minHeight: 40,
            fontSize: 13,
        },
        width: '100%',
        minWidth: '100%',
        marginTop: 10,
        height: 55,
        minHeight: 55,
        fontSize: 18,
        fontWeight: 500,
        alignSelf: 'flex-start',
        borderRadius: 10,
    },
    error: {
        color: 'red',
        fontSize: 13,
        marginTop: 2,
        marginBottom: 0,
    },
    link: {
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 14,
        },
        fontSize: 14,
        color: theme.linkColor,
        cursor: 'pointer',
        fontWeight: 500,
        textAlign: 'left',
    },
    forgotPasswordLink: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 12,
        },
        fontSize: 13,
        marginTop: 10,
    },
    terms: {
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 12,
        },
        [`@media (max-width: ${theme.breakpoints.minuscule}px)`]: {
            fontSize: 10,
        },
        fontSize: 13,
        textAlign: 'center',
        color: theme.textColor,
        marginBottom: 20,
    },
    closeIconWrapper: {
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        right: 0,
        width: 100,
        height: 70,
    },
    closeIcon: {
        position: 'absolute',
        top: 18,
        right: 25,
        width: 16,
        height: 16,
        cursor: 'pointer',
    },
    chatToUs: {
        marginTop: 30,
        fontSize: 15,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
});

const styles = StyleSheet.create({
    modalWrapper: {
        [newtheme.cssBreakpoints.small]: {
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
        },
        [newtheme.cssBreakpoints.tiny]: {
            padding: '30px 20px',
        },
        maxWidth: '100%',
        fontFamily: 'Poppins',
        display: 'flex',
        flexDirection: 'row',
    },
});

export default SignupForSpecialAccessModalComponent;
